import { render, staticRenderFns } from "./vsDropdownMenu.vue?vue&type=template&id=d7a58f7e&lang=html"
import script from "./vsDropdownMenu.vue?vue&type=script&lang=js"
export * from "./vsDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports